module.exports = __webpack_public_path__ + "img/banner-one1.b8010748.png";